/** Default marketing copy & media for Home — editable via Admin → Site content */

export const homeContentDefaults = {
  whatsappNumber: "917780291217",

  /** Header + footer social icons — full URLs (https://...) */
  socialLinks: {
    instagram: "https://www.instagram.com/_party_boss/",
    youtube: "https://www.youtube.com/@PartyBoss93",
    facebook: "https://www.facebook.com/61569713386163/",
  },

  hero: {
    backgroundVideoUrl: "/videos/cms-defaults/hero-background.mp4",
    cardVideoUrl: "/videos/cms-defaults/hero-card.mp4",
    badge: "✨ Premium Private Theatre Celebrations in Hyderabad",
    titleBeforeGradient: "Celebrate Your Moments with",
    titleGradient: "Luxury Cinema Magic",
    subtitle:
      "Welcome to Party Boss — your premium destination for birthdays, anniversaries, surprises, parties, banquets and private theatre celebrations with cinematic visuals, rich sound, décor, food and unforgettable memories.",
    primaryCta: "Book Theatre Now",
    secondaryCta: "Explore Celebrations",
    heroCardBadge: "Just Pay ₹700 Now",
    heroCardTitle: "Big Screen Celebration",
    heroCardText:
      "Private theatre, luxury ambience, décor, food, banquet options and cinematic celebration experience.",
  },

  celebrationsIntro: {
    id: "celebrations",
    eyebrow: "Celebration Types",
    title: "Celebrate Every Special Occasion",
    text: "Party Boss is designed for private celebrations, family gatherings, romantic surprises and premium group events.",
  },

  celebrations: [
    {
      title: "Birthday Party",
      text: "Big screen birthday celebration with décor, cake, music and private theatre vibes.",
      imageUrl: "/images/cms-defaults/celebration-birthday.jpg",
    },
    {
      title: "Anniversary",
      text: "Romantic private theatre setup for couples with cinematic memories and premium ambience.",
      imageUrl: "/images/cms-defaults/celebration-anniversary.jpg",
    },
    {
      title: "Surprise Party",
      text: "Create unforgettable surprise entries, fog entry, cake entry and customised decoration.",
      imageUrl: "/images/cms-defaults/celebration-surprise.jpg",
    },
    {
      title: "Party & Events",
      text: "Perfect for reunions, farewell parties, friends gatherings and private social events.",
      imageUrl: "/images/cms-defaults/celebration-events.jpg",
    },
  ],

  luxuryIntro: {
    eyebrow: "Why Celebrate at Party Boss",
    title: "Private, Premium and Fully Celebration Ready",
    text: "Everything you need for a beautiful celebration is available in one place.",
  },

  luxuryCards: [
    [
      "🎬",
      "Private Theatre",
      "Exclusive cinema space for your group, so you can celebrate privately without disturbance.",
    ],
    [
      "🎊",
      "Custom Decoration",
      "Birthday, anniversary, romantic and theme-based décor options are available.",
    ],
    [
      "🍽️",
      "Food Available",
      "Different food options, snacks, beverages, cake and party add-ons can be arranged.",
    ],
    [
      "🏛️",
      "Banquet Option",
      "Banquet-style arrangements are available for group celebrations and special events.",
    ],
  ],

  foodSection: {
    imageUrl: "/images/cms-defaults/food-section.jpg",
    eyebrow: "Food & Banquet Add-ons",
    title: "Food, Snacks, Cake & Banquets Available",
    body:
      "Party Boss provides different food options for celebrations. You can add snacks, beverages, cake, fog entry, bubble entry, banquet-style arrangements and customised food packages based on your event type and guest count.",
    tags: [
      "🍿 Popcorn",
      "🥤 Beverages",
      "🎂 Cake Add-on",
      "🍕 Snacks",
      "🍽️ Food Packages",
      "🏛️ Banquet Available",
      "🌫️ Fog Entry",
      "🎁 Bubble Entry",
    ],
  },

  advantagesIntro: {
    eyebrow: "Party Boss Advantages",
    title: "More Than Just a Private Theatre",
    text: "Party Boss gives you a premium celebration experience with theatre, food, décor, add-ons and memories.",
  },

  advantageCards: [
    [
      "📍",
      "Prime Location",
      "Easy-to-reach Hyderabad location with comfortable private celebration spaces.",
    ],
    [
      "💰",
      "Budget Friendly",
      "Premium celebration packages starting from affordable prices with pay-now booking.",
    ],
    [
      "👥",
      "Multiple Capacities",
      "Choose small couple spaces or larger theatres for friends, families and groups.",
    ],
    [
      "📸",
      "Photo Moments",
      "Beautiful ambience and décor make your photos, reels and memories look premium.",
    ],
  ],

  bookingIntro: {
    id: "booking",
    eyebrow: "",
    title: "",
    text: "",
  },

  /** Marketing cards on home (demo theatres — not live API slots) */
  marketingTheatres: [
    {
      key: "mercury",
      name: "Mercury Theatre",
      imageUrl: "/images/cms-defaults/marketing-mercury.jpg",
      theatreVideoUrl: "",
      branchVideoUrl: "",
      location: "Himayatnagar",
      slotsLabel: "1 Slot Available",
      slotsTone: "red",
      capacity: "Max 4 People",
      decor: "Decor ₹750 extra",
      price: "₹1299",
      priceText: "for up to 2 people",
      extra: "+ ₹299/person after 2 people",
      times: [
        "10:30 AM - 12:00 PM",
        "12:30 PM - 3:30 PM",
        "4:00 PM - 5:30 PM",
        "6:00 PM - 9:00 PM",
        "9:30 PM - 12:30 AM",
      ],
    },
    {
      key: "galaxy",
      name: "Galaxy Theatre",
      imageUrl: "/images/cms-defaults/marketing-galaxy.jpg",
      theatreVideoUrl: "",
      branchVideoUrl: "",
      location: "Himayatnagar",
      slotsLabel: "4 Slots Available",
      slotsTone: "gray",
      capacity: "Max 20 People",
      decor: "Decor ₹699 extra",
      price: "₹1799",
      priceText: "for up to 4 people",
      extra: "+ ₹299/person after 4 people",
      times: [
        "11:00 AM - 12:30 PM",
        "1:00 PM - 4:00 PM",
        "4:30 PM - 7:30 PM",
        "8:00 PM - 11:00 PM",
        "11:30 PM - 1:00 AM",
      ],
    },
    {
      key: "jupiter",
      name: "Jupiter Theatre",
      imageUrl: "/images/cms-defaults/marketing-jupiter.jpg",
      theatreVideoUrl: "",
      branchVideoUrl: "",
      location: "Himayatnagar",
      slotsLabel: "2 Slots Available",
      slotsTone: "red",
      capacity: "Max 12 People",
      decor: "Decor ₹699 extra",
      price: "₹1699",
      priceText: "for up to 4 people",
      extra: "+ ₹299/person after 4 people",
      times: [
        "10:00 AM - 1:00 PM",
        "2:00 PM - 5:00 PM",
        "6:00 PM - 9:00 PM",
        "10:00 PM - 1:00 AM",
      ],
    },
  ],

  galleryIntro: {
    id: "gallery",
    eyebrow: "",
    title: "",
    text: "",
  },

  gallery: [
    {
      title: "Luxury Birthday Setup",
      imageUrl: "/images/cms-defaults/gallery-luxury-birthday.jpg",
      big: true,
    },
    {
      title: "Balloon Décor",
      imageUrl: "/images/cms-defaults/celebration-birthday.jpg",
      big: false,
    },
    {
      title: "Anniversary Moments",
      imageUrl: "/images/cms-defaults/celebration-anniversary.jpg",
      big: false,
    },
    {
      title: "Party Celebration",
      imageUrl: "/images/cms-defaults/celebration-surprise.jpg",
      big: false,
    },
    {
      title: "Special Surprise",
      imageUrl: "/images/cms-defaults/gallery-special-surprise.jpg",
      big: false,
    },
  ],

  finalCta: {
    title: "Your Celebration Deserves Party Boss",
    subtitle:
      "Book your private theatre, add food, décor, cake, banquet setup and premium celebration add-ons. Make your special moment unforgettable.",
    primaryLabel: "Book now",
    whatsappLabel: "WhatsApp us",
    whatsappPreset: "Hi Party Boss, I want to book a private theatre",
    bgImageUrl: "/images/cms-defaults/celebration-events.jpg",
  },

  footer: {
    title: "Ready to Reserve Your Private Theatre?",
    body:
      "Contact Party Boss today and let the cinematic celebration begin with luxury décor, food, banquet options and memories.",
    bookLabel: "Book now",
    whatsappLabel: "WhatsApp",
    partyBossBlurb: "",
    contactLines: [
      "Miyapur, Hyderabad, Telangana",
      "Phone / WhatsApp: +91 7780291217",
      "Email: info@partyboss.in",
    ],
    copyrightName: "Party Boss",
  },

  floatingBookLabel: "Book now",

  /** Header promo strip + welcome popup — edit in Admin → Site content */
  promoBanner: {
    enabled: true,
    text: "Rush!! Get flat discount of ₹300/-",
  },

  promoPopup: {
    enabled: true,
    eyebrow: "✨ Exclusive at Party Boss",
    title: "Flat ₹300 off your booking",
    body:
      "Rush!! Get a flat ₹300 off your celebration booking. Use promo code PARTY300 at checkout (minimum bill applies). Book now and celebrate in style!",
    ctaLabel: "Book now",
    ctaPath: "/booknow",
    dismissLabel: "Maybe later",
    /** If true, popup hides for the rest of the browser session after dismiss */
    showOncePerSession: true,
  },
};
